import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
@Component({
    selector: 'fcp-alert',
    templateUrl: './fcp-alert.component.html',
    styleUrls: ['./fcp-alert.component.less'],
    standalone: false
})
export class FcpAlertComponent implements OnChanges {
    @Input() type: Type = Type.Success;
    @Input() showClose = false;
    @Input() additionalText = { show: false, value: '', action: null };
    @Input() size: Size = Size.Responsive;
    iconName = 'check-circle';
    public show = true;

    @Output() private alertClosed: EventEmitter<void> = new EventEmitter<void>();

    ngOnChanges(changes: SimpleChanges) {
        const mapping = {
            [Type.Success]: 'check-circle',
            [Type.Error]: 'circle-exclamation',
            [Type.Warning]: 'triangle-exclamation',
            [Type.Info]: 'info-circle'
        };
        if (changes.type?.currentValue) {
            this.iconName = mapping[changes.type.currentValue];
        }
    }

    onClickAlertClosed() {
        this.show = false;
        this.alertClosed.emit();
    }

    public handleAction() {
        this.additionalText.action();
    }
}

export enum Type {
    Warning = 'warning',
    Error = 'critical',
    Success = 'success',
    Info = 'info'
}

export enum Size {
    Responsive = 'responsive',
    Large = 'large'
}
